/**
 * SQPR "settled" predicate: some Fawcett requests are never fulfilled, so a run
 * counts as done once it's close enough or old enough. Pure function of the
 * progress payload — `sqpr_dispatched_at` comes from the backend, so no local
 * state is needed. Kept React-free to avoid an import cycle with the workflows
 * hooks.
 */
const SQPR_DONE_FRACTION = 0.9;
const SQPR_HARD_STOP_MS = 14 * 24 * 60 * 60 * 1000;
const SQPR_FIRST_WEEK_GRACE_MS = 6 * 60 * 60 * 1000;

export const sqprNothingRequested = (
  sqpr: readonly [number, number] | null | undefined,
  dispatchedAt: string | null | undefined,
): boolean => {
  if (!sqpr || !dispatchedAt) return false;
  const [completed, total] = sqpr;
  if (total <= 0 || completed > 0) return false;
  return Date.now() - new Date(dispatchedAt).getTime() >= SQPR_FIRST_WEEK_GRACE_MS;
};

export const sqprStillImporting = (
  sqpr: readonly [number, number] | null | undefined,
  dispatchedAt: string | null | undefined,
): boolean => {
  if (!sqpr || !dispatchedAt) return false;
  const [completed, total] = sqpr;
  if (total <= 0 || completed / total >= SQPR_DONE_FRACTION) return false;
  if (sqprNothingRequested(sqpr, dispatchedAt)) return false;
  return Date.now() - new Date(dispatchedAt).getTime() < SQPR_HARD_STOP_MS;
};
